<template>
  <div>
    <v-tooltip open-delay="500" top>
      <template #activator="{ on, attrs }">
        <v-btn :disabled="disabled" x-small icon v-bind="attrs" v-on="on" @click.stop="mudarEstadoDialog">
          <v-icon small v-text="'mdi-information-outline'" />
        </v-btn>
      </template>
      <span>Detalhamento das últimas compras</span>
    </v-tooltip>

    <v-dialog
      v-model="dialog_ativo"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title class="text-white px-2" style="background: #042333;">
          <v-btn icon dark class="mr-5">
            <v-icon @click.stop="mudarEstadoDialog">mdi-close</v-icon>
          </v-btn>

          <span>Últimas compras</span>
        </v-card-title>

        <v-card-text class="py-0 pt-4 px-2">
          <v-data-table
            height="calc(100vh - 170px)"
            :headers="headers"
            :items="items"
            class="table-full-screen"
            :items-per-page="-1"
            fixed-header
          >
            <template v-slot:top>
              <slot name="topo-tabela" />
            </template>

            <template #item.razao_social="{item}">
              {{ item.fornecedor }}
            </template>

            <template #item.qtde="{item}">
              {{ Helpers.formatarValor(item.qtde) }}
            </template>

            <template #item.qtde_pendente="{item}">
              {{ Helpers.formatarValor(item.qtde_pendente) }}
            </template>

            <template #item.preco_unitario="{item}">
              {{ Helpers.formatarValorMonetario(item.preco_unitario) }}
            </template>

            <template #item.total_compra="{item}">
              {{ Helpers.formatarValorMonetario(item.total_compra) }}
            </template>

            <template #item.preco_unitario_anterior="{item}">
              {{ Helpers.formatarValorMonetario(item.preco_unitario_anterior) }}
            </template>

            <template #item.indicador_preco="{item}">
              <div :title="Helpers.formatarValorPercent(item.indicador_preco)">
                <v-icon v-if="parseFloat(item.indicador_preco) > 0" color="red darken-2">mdi-arrow-up</v-icon>
                <v-icon v-else-if="parseFloat(item.indicador_preco) < 0" color="green darken-2">mdi-arrow-down</v-icon>
              </div>
            </template>

            <template #item.tempo_entrega="{item}">
              <div v-if="parseInt(item.atraso) < 0" class="text-green">
                {{ Math.abs(item.atraso) }} {{ Math.abs(item.atraso) > 1 ? 'dias' : 'dia'}}
              </div>
              <div v-if="parseInt(item.atraso) === 0">
                {{ Math.abs(item.tempo_entrega) }} {{ Math.abs(item.tempo_entrega) > 1 ? 'dias' : 'dia'}}
              </div>
              <div v-if="parseInt(item.atraso) > 0" class="text-red">
                atraso de {{ item.atraso }} {{ item.atraso > 1 ? 'dias' : 'dia'}}
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RequisicaoAPI from "../../../../api/Requisicao";
import {logout} from "../../../../helpers";

export default {
  name: "UltimasCompras",
  props: {
    filtros: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    dialog_ativo: false,
    headers: [
      {text: 'Produto', value: 'produto'},
      { text: "Filial", value: "filial" },
      { text: "Pedido", value: "ordem_compra" },
      { text: "Razão Social", value: "razao_social" },
      { text: "Dt. Solicitação", value: "data_solicitacao" },
      { text: "Dt. Previsão", value: "data_previsao" },
      { text: "Dt. Entrada", value: "data_entrega" },
      { text: "Dt. Faturamento", value: "data_faturamento" },
      {text: "UND", value: "unidade_compra"},
      { text: "Qtde.", value: "qtde" },
      { text: "Qtde. Pendente", value: "qtde_pendente" },
      { text: "Valor Unit.", value: "preco_unitario" },
      { text: "Valor Unitário Anterior", value: "preco_unitario_anterior" },
      { text: "Indicador", value: "indicador_preco" },
      { text: "Total", value: "total_compra" },
      { text: "Tempo entrega", value: "tempo_entrega" },
    ],
    items: []
  }),
  methods: {
    mudarEstadoDialog() {
      this.dialog_ativo = !this.dialog_ativo;

      if (this.dialog_ativo) {
        this.items = [];
        this.getPedidosEmAberto();
      }
    },
    getPedidosEmAberto() {
      const parametros = {
        grupo: this.filtros.grupo,
        iddepartamento: this.filtros.iddepartamento,
        idsecao: this.filtros.idsecao,
        idcategoria: this.filtros.idcategoria,
        idproduto: this.filtros.idproduto
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        RequisicaoAPI.buscarUltimasComprasDepartamento(parametros)
          .then(resp => {
            const {token, compras} = resp.data
            localStorage.token = token
            this.items = compras;
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>

</style>
